import { tokens } from '../tokens';
function mediaQueryFromBreakpoint(breakpoint) {
    return "@media screen and (min-width: ".concat(breakpoint, ")");
}
var mediaQuery = {
    aboveSmall: mediaQueryFromBreakpoint(tokens.breakpoints.small),
    aboveMedium: mediaQueryFromBreakpoint(tokens.breakpoints.medium),
    aboveLarge: mediaQueryFromBreakpoint(tokens.breakpoints.large),
};
export default mediaQuery;
